<div class="min-h-screen bg-[#F8F9FA] p-4 md:p-6 font-sans text-slate-800">
  
  <!-- INTEGRATED PROFILE SECTION (Always Visible) -->
  <div class="bg-white rounded-3xl p-6 mb-8 border border-slate-200 shadow-sm overflow-hidden relative">
    <div class="absolute top-0 right-0 w-32 h-32 bg-[#f6f1cb] rounded-bl-full opacity-50"></div>
    
    <div class="relative z-10 flex flex-col md:flex-row items-center gap-6">
      <div class="relative">
        <img [src]="userData?.documents?.[0]?.doc_user_img || '/assets/images/rmportal/staff.png'" class="w-24 h-24 rounded-2xl border-4 border-[#C19725] p-1 bg-white">
      </div>
      
      <div class="flex-1 text-center md:text-left">
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 class="text-2xl font-black text-slate-800">{{ userData.name }} {{ userData.user_last_name }}</h1>
            <p class="text-[#C19725] font-bold text-sm">Sales executive • ID: #{{ userData.id }}</p>
          </div>
          
          <!-- RESET PASSWORD TOGGLE BUTTON -->
          <button 
            (click)="isResettingPassword = !isResettingPassword"
            class="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl text-xs font-bold uppercase tracking-wider transition-all"
            [ngClass]="isResettingPassword ? 'bg-slate-100 text-slate-600 hover:bg-slate-200' : 'bg-[#C19725]/10 text-[#C19725] hover:bg-[#C19725] hover:text-white'">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
            </svg>
            {{ isResettingPassword ? 'Back to Dashboard' : 'Reset Password' }}
          </button>
        </div>
        
        <div class="mt-4 flex flex-wrap justify-center md:justify-start gap-y-2 gap-x-6 text-xs font-medium text-slate-500">
          <span class="flex items-center gap-1"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke-width="2"/></svg> {{ userData.email }}</span>
          <span class="flex items-center gap-1"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" stroke-width="2"/></svg> {{ userData.mobilenumber }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- CONDITIONAL VIEW SWITCHER -->
  <ng-container *ngIf="!isResettingPassword; else resetPasswordView">
    
    <!-- MAIN MODULES GRID (Hides when Reset Password is open) -->
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      
      <!-- LEFT: STOCK & SALES -->
      <div class="lg:col-span-8 space-y-6">
        
        <!-- Stock Module -->
        <div class="bg-white rounded-3xl p-6 border border-slate-200 shadow-sm">
          <h2 class="text-xs font-black text-slate-400 uppercase tracking-widest mb-6 flex items-center gap-2">
            <span class="w-2 h-2 bg-[#C19725] rounded-full"></span> Inventory (Stock)
          </h2>
          
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div routerLink="/rm-portal/available-stock" class="col-span-2 cursor-pointer p-6 bg-[#f6f1cb] rounded-2xl border border-[#C19725]/20 flex items-center justify-between hover:shadow-md transition-all">
              <div>
                <p class="text-3xl font-black text-slate-800">{{ stats.totalStock }}</p>
                <p class="text-[11px] font-bold text-[#C19725] uppercase">Available (Total) Stock</p>
              </div>
              <svg class="w-10 h-10 text-[#C19725] opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" stroke-width="2"/></svg>
            </div>

            <div routerLink="/rm-portal/new-stock" class="cursor-pointer p-4 bg-slate-50 rounded-2xl border border-transparent hover:border-[#C19725] transition-all">
              <p class="text-xl font-black text-slate-800">{{ stats.newStockToday }}</p>
              <p class="text-[10px] font-bold text-slate-400 uppercase tracking-tighter">New Today</p>
            </div>

            <div routerLink="/rm-portal/submitted-stock" class="cursor-pointer p-4 bg-slate-50 rounded-2xl border border-transparent hover:border-[#C19725] transition-all">
              <p class="text-xl font-black text-slate-800">{{ stats.submittedStock }}</p>
              <p class="text-[10px] font-bold text-slate-400 uppercase tracking-tighter">Submitted</p>
            </div>
          </div>
        </div>

        <!-- Sales & Udhar Row -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Udhar (Collection) -->
          <div routerLink="/rm-portal/pending-payment" class="cursor-pointer bg-white rounded-3xl p-6 border-r-4 border-r-[#BB0000] shadow-sm hover:shadow-md transition-all">
            <p class="text-[10px] font-black text-[#BB0000] uppercase tracking-widest mb-2">Udhar (Pending)</p>
            <p class="text-3xl font-black text-slate-800">₹{{ stats.pendingUdhar | number }}</p>
            <div class="mt-4 flex items-center justify-between">
               <span class="text-[10px] font-bold text-slate-400">Collect Payments</span>
               <svg class="w-5 h-5 text-[#BB0000]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M17 8l4 4m0 0l-4 4m4-4H3" stroke-width="2"/></svg>
            </div>
          </div>

          <!-- Sales History -->
          <div routerLink="/rm-portal/sold-stock" class="cursor-pointer bg-white rounded-3xl p-6 border-r-4 border-r-[#1F8C11] shadow-sm hover:shadow-md transition-all">
            <p class="text-[10px] font-black text-[#1F8C11] uppercase tracking-widest mb-2">Sales History</p>
            <p class="text-3xl font-black text-slate-800">{{ stats.soldStock }}</p>
            <div class="mt-4 flex items-center justify-between">
               <span class="text-[10px] font-bold text-slate-400">Total Items Sold</span>
               <svg class="w-5 h-5 text-[#1F8C11]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2"/></svg>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT: QUICK ACTIONS & OPERATIONS -->
      <div class="lg:col-span-4 space-y-6">
        
        <!-- Quick Buttons -->
        <div class="grid grid-cols-2 gap-4">
          <button class="bg-[#C19725] text-white p-4 rounded-2xl font-black text-xs uppercase shadow-lg shadow-[#C19725]/20 hover:scale-[1.02] transition-transform cursor-pointer" routerLink="/rm-portal/sell-customer">
            Sell Item
          </button>
          <button class="bg-slate-800 text-white p-4 rounded-2xl font-black text-xs uppercase shadow-lg shadow-slate-800/20 hover:scale-[1.02] transition-transform cursor-pointer" routerLink="/create-user/add-customer">
            Add Customer
          </button>
        </div>

        <!-- Operations Modules -->
        <div class="bg-white rounded-3xl p-6 border border-slate-200 shadow-sm space-y-4">
          <h3 class="text-[10px] font-black text-slate-400 uppercase tracking-widest">Operations</h3>
          
          <div routerLink="/rm-portal/expense" class="cursor-pointer flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-red-50 text-[#BB0000] rounded-lg"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2" stroke-width="2"/></svg></div>
              <span class="text-xs font-bold text-slate-600 tracking-tight">Expenses</span>
            </div>
            <span class="text-sm font-black">₹{{ stats.totalExpenses | number }}</span>
          </div>

          <div routerLink="/rm-portal/assets" class="cursor-pointer flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-blue-50 text-blue-600 rounded-lg"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" stroke-width="2"/></svg></div>
              <span class="text-xs font-bold text-slate-600 tracking-tight">My Assets</span>
            </div>
            <span class="text-sm font-black">{{ stats.assignedAssets }}</span>
          </div>

          <div class="p-4 bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl text-white cursor-pointer" routerLink="/rm-portal/incentive">
            <div class="flex justify-between items-center mb-2">
              <span class="text-[9px] font-bold uppercase opacity-60 tracking-widest">Monthly Target</span>
              <span class="text-[9px] font-bold uppercase opacity-60 tracking-widest">{{ targetData.month }}</span>
            </div>
            <div class="w-full bg-white/10 h-1.5 rounded-full mb-3">
              <div class="bg-[#1F8C11] h-full rounded-full" [style.width.%]="(targetData.achieved/targetData.total)*100"></div>
            </div>
            <p class="text-lg font-black tracking-tight">₹{{ targetData.achieved | number }} Achieved</p>
          </div>
        </div>
      </div>
    </div> <!-- END OF MAIN MODULES GRID -->

  </ng-container>

  <!-- RESET PASSWORD VIEW (Shows when Reset Password is open) -->
  <ng-template #resetPasswordView>
    <div class="max-w-10xl mx-auto mt-4 animate-in fade-in slide-in-from-top-4 duration-300">
        
        <!-- Render your newly created Reset Password component here -->
        <app-staff-reset-password [staffData]="userData"></app-staff-reset-password>
        
        <!-- Cancel/Return Button -->
        <div class="text-center mt-6">
            <button (click)="isResettingPassword = false" class="text-slate-400 hover:text-[#C19725] text-xs font-bold uppercase tracking-widest transition-colors">
                &larr; Cancel and return to Dashboard
            </button>
        </div>
    </div>
  </ng-template>

</div> <!-- END OF MAIN CONTAINER -->